import { images } from '../constants';

export const legends = [ 
    {
        id: 1,
        image: images.legends1,
        title: "legends.item1.title",
        subtitle: "legends.item1.subtitle",
        date: "legends.item1.date",
        author: "legends.item1.author",
        readTime: "legends.item1.readTime",
        content: "legends.item1.content",
    },
    {
        id: 2,
        image: images.legends2,
        title: "legends.item2.title",
        subtitle: "legends.item2.subtitle",
        date: "legends.item2.date",
        author: "legends.item2.author",
        readTime: "legends.item2.readTime",
        content: "legends.item2.content",
    },
    {
        id: 3,
        image: images.legends2,
        title: "legends.item3.title",
        subtitle: "legends.item3.subtitle",
        date: "legends.item3.date",
        author: "legends.item3.author",
        readTime: "legends.item3.readTime",
        content: "legends.item3.content",
    },
    {
        id: 4,
        image: images.legends2,
        title: "legends.item4.title",
        subtitle: "legends.item4.subtitle",
        date: "legends.item4.date",
        author: "legends.item4.author",
        readTime: "legends.item4.readTime",
        content: "legends.item4.content",
    },
    {
        id: 5,
        image: images.legends2,
        title: "legends.item5.title",
        subtitle: "legends.item5.subtitle",
        date: "legends.item5.date",
        author: "legends.item5.author",
        readTime: "legends.item5.readTime",
        content: "legends.item5.content",
    },
    {
        id: 6,
        image: images.legends2,
        title: "legends.item6_bday.title",
        subtitle: "legends.item6_bday.subtitle",
        date: "legends.item6_bday.date",
        author: "legends.item6_bday.author",
        readTime: "legends.item6_bday.readTime",
        content: "legends.item6_bday.content",
    },
    {
        id: 7,
        image: images.legends2,
        title: "legends.item6_bell.title",
        subtitle: "legends.item6_bell.subtitle",
        date: "legends.item6_bell.date",
        author: "legends.item6_bell.author",
        readTime: "legends.item6_bell.readTime",
        content: "legends.item6_bell.content",
    },
    {
        id: 8,
        image: images.legends2,
        title: "legends.item7.title",
        subtitle: "legends.item7.subtitle",
        date: "legends.item7.date",
        author: "legends.item7.author",
        readTime: "legends.item7.readTime",
        content: "legends.item7.content",
    },
    {
        id: 9,
        image: images.legends2,
        title: "legends.item8.title",
        subtitle: "legends.item8.subtitle",
        date: "legends.item8.date",
        author: "legends.item8.author",
        readTime: "legends.item8.readTime",
        content: "legends.item8.content",
    },
    {
        id: 10,
        image: images.legends2,
        title: "legends.item9.title",
        subtitle: "legends.item9.subtitle",
        date: "legends.item9.date",
        author: "legends.item9.author",
        readTime: "legends.item9.readTime",
        content: "legends.item9.content",
    }
];

export default legends;